/** @jsxImportSource preact */
import type { OrderStatusData, PaymentStatus } from '../types';

interface OrderStatusBadgeProps {
  data: OrderStatusData;
}

const STATUS_LABELS: Record<PaymentStatus, string> = {
  paid: 'Pago confirmado',
  pending: 'Pago pendiente',
  failed: 'Pago rechazado',
  expired: 'Pago expirado',
  refunded: 'Pago reembolsado',
};

const STATUS_COLORS: Record<PaymentStatus, string> = {
  paid: 'green',
  pending: 'amber',
  failed: 'red',
  expired: 'slate',
  refunded: 'blue',
};

function formatTotal(total: number | null | undefined, currency: string | null | undefined): string {
  if (typeof total !== 'number' || !Number.isFinite(total)) return '';
  const amount = total.toLocaleString('es-AR');
  return currency ? `${currency} ${amount}` : `$${amount}`;
}

/**
 * Compact order_status pill + secondary line. Used by the envelope
 * renderer for the `order_status` message type and shared by the
 * CHECKOUT_COMPLETE iframe handshake (via the host).
 */
export function OrderStatusBadge({ data }: OrderStatusBadgeProps) {
  if (!data || !data.order_id) return null;

  const status = (data.payment_status || 'pending') as PaymentStatus;
  const label = STATUS_LABELS[status] || data.payment_status;
  const color = STATUS_COLORS[status] || 'slate';
  const ref = data.order_number || data.order_id;
  const totalStr = formatTotal(data.total, data.currency);

  return (
    <div class="lc-order-status" data-status={status}>
      <div class="lc-order-status-row">
        <span
          class={`lc-order-status-pill lc-order-status-pill--${color}`}
          data-color={color}
        >
          {label}
        </span>
        <span class="lc-order-status-ref">Orden #{ref}</span>
      </div>
      {totalStr ? (
        <div class="lc-order-status-total">Total: {totalStr}</div>
      ) : null}
    </div>
  );
}
